// extracted by mini-css-extract-plugin
module.exports = {"mention":"styles_mention__3tNFC","focusedMention":"styles_focusedMention__2P7nF"};